import { ContractInfo } from 'app/core/store/contract-info/contract-info.interface';
import { ContractInfoLevel } from './contract-info.enum';

export const initialState: ContractInfo = {
  loadFromLevel: ContractInfoLevel.NONE,
  loadToLevel: ContractInfoLevel.NONE,
  loadIds: [],
  loading: false,
  loaded: false,
  failed: false,
  orderTypes: [],
  flowRegistrationTypes: [],
  flowHandshakeTypes: [],
  handshakes: {},
};
